import React from 'react';

import { getShopifyPercentageDiscountedPrice } from '../../utils/discounts';

const formatMoney = (value) => {
  if (value == null) return '';
  return `$${Number(value).toFixed(2)}`;
};

export default function ShareablePackageSelector({ packages, selectedPackageId, onSelect, basePrice }) {
  if (!packages?.length) return null;

  return (
    <div className="product-sku product-sku-package">
      <div className="product-sku-title">Package:</div>
      <ul className="product-sku-list product-sku-list--packages">
        {packages.map((pkg) => {
          const isSelected = selectedPackageId === pkg.id;
          const unitPrice = pkg.useBasePrice
            ? basePrice
            : pkg.pricePerBook != null
            ? pkg.pricePerBook
            : pkg.percentage
            ? getShopifyPercentageDiscountedPrice(basePrice, pkg.percentage)
            : pkg.pricePerBook;
          const priceLabel = `${formatMoney(unitPrice)} / book`;

          return (
            <li
              key={pkg.id}
              className={`product-sku-item product-sku-item--package ${isSelected ? 'selected' : ''}`}
              onClick={() => onSelect(pkg)}
            >
              <span className="product-sku-item-type">{pkg.packageLabel}</span>
              <span className="product-sku-item-meta">{pkg.quantityLabel} books</span>
              <span className="product-sku-item-price">{priceLabel}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
